// 活動 元件
import { EVENTS_FILTER_MAP } from '@/common/constant';
import Image from 'next/image';
import Link from 'next/link';
import dayjs from 'dayjs';
import EventsTag from '../events/EventsTag';

const EventComponent = ({ t, info }) => {
    const beginTime = info?.beginTime ? dayjs(info?.beginTime).format('YYYY.MM.DD HH:mm') : '---';
    const progressStatus = info?.progressStatus;
    const filterKeys = Object.keys(EVENTS_FILTER_MAP);
    const filterKey = filterKeys[progressStatus];
    const title = info?.title;

    // 標籤篩選 因為陣列裡可能會有 null 的回傳
    const label = info?.label?.filter?.((v) => v === 'offline' || v === 'online')?.[0] || null;

    const place = info?.place;
    const image = info?.imageFb || '/images/news/default_related.svg';
    const slug = info?.slug;

    const activityProcessColor = (process) => {
        // 1:進行中, 2:即將開始, 3:已結束)
        switch (process) {
            case 1:
                return 'bg-pale';
            case 2:
                return 'bg-black2';
            case 3:
                return 'bg-black';
        }
    };
    if (!info) return <></>;

    return (
        <Link href={`/events/${slug}`} className="group space-y-[15px]">
            {/* 活動圖片 */}
            <div className="img-box w-full aspect-[362/233] rounded-[4px] overflow-hidden after:content-none">
                <Image
                    className="hover-img"
                    width={362}
                    height={233}
                    src={image || '/images/news/default_related.svg'}
                    alt="event_image"
                    sizes="360px"
                />
            </div>

            {/* 活動類別 */}
            {label ? (
                <p className="inline-block text-btn1 text-black border-b-1 border-black pb-[2px]">
                    {t(label?.toUpperCase())}
                </p>
            ) : (
                ''
            )}

            {/* 活動標題 */}
            <h2 className="text-bd2b text-black  hover-text">{title}</h2>

            <p className="flex items-center justify-start space-x-[17px] text-btn1">
                <EventsTag content={t(filterKey)} color={activityProcessColor(progressStatus)} />

                <span className="text-black">{beginTime}</span>
            </p>

            {/* 活動地點 */}
            <p className="text-btn1 text-pale9 9">{place}</p>
        </Link>
    );
};

export default EventComponent;
